"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));

var _default = function _default(collection) {
  var targetActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['add', 'remove'];

  var _useState = (0, _react.useState)((0, _uniqueId2["default"])()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1],
      actions = Array.isArray(targetActions) ? targetActions : [targetActions],
      eventHandler = function eventHandler() {
    return setValue((0, _uniqueId2["default"])());
  };

  (0, _react.useEffect)(function () {
    actions.forEach(function (action) {
      return collection === null || collection === void 0 ? void 0 : collection.on(action, eventHandler);
    });
    return function () {
      actions.forEach(function (action) {
        return collection === null || collection === void 0 ? void 0 : collection.off(action, eventHandler);
      });
    };
  }, [targetActions, collection]);
  return [collection];
};

exports["default"] = _default;